import { render, staticRenderFns } from "./payOrdersTG.vue?vue&type=template&id=7f32c39a&scoped=true"
import script from "./payOrdersTG.vue?vue&type=script&lang=js"
export * from "./payOrdersTG.vue?vue&type=script&lang=js"
import style0 from "./payOrdersTG.vue?vue&type=style&index=0&id=7f32c39a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f32c39a",
  null
  
)

export default component.exports